export default __webpack_public_path__ + "static/media/SHEEP.ba631025.gif";